import { render, staticRenderFns } from "./rebrickable.vue?vue&type=template&id=84a635ba&scoped=true"
import script from "./rebrickable.vue?vue&type=script&lang=js"
export * from "./rebrickable.vue?vue&type=script&lang=js"
import style0 from "./rebrickable.vue?vue&type=style&index=0&id=84a635ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a635ba",
  null
  
)

export default component.exports